module.exports = __webpack_public_path__ + "static/media/person-dolly-empty.31798306.svg";